module.exports = require("colors");


//////////////////
// WEBPACK FOOTER
// external "colors"
// module id = 31
// module chunks = 0